import React from 'react';

import {TelehealthConfirmationBooking} from 'presentation/modules/booking/telehealth/ui/pages/TelehealthConfirmationBooking';

export const MakeTelehealthConfirmationBooking = () => {
	return <TelehealthConfirmationBooking />;
};
